// router
import { useNavigate } from 'react-router-dom';

// theme
import logo from 'assets/svg/ChicagoEvertoniansLogo.svg';
import styles from './Mascot.module.scss';

function Mascot() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      navigate('/');
    }
  };

  return (
    <div
      className={styles.mascot}
      role='button'
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={0}
    >
      <img src={logo} alt='' />
    </div>
  );
}

export default Mascot;
